import DeleteIcon from "@mui/icons-material/Delete"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useAppDispatch, useAppSelector } from "hooks"
import { useState } from "react"
import licensePoolService from "services/licensePoolService"
import licenseService from "services/licenseService"
import { setCurrentLicensePool, updateLicensePool } from "slices/licensePoolSlice"
import { removeLicense } from "slices/licenseSlice"
import { hiabColors } from "theme"
import type { ILicense } from "types/licenseTypes"

type Props = {
  license: ILicense
}

export function DeleteLicenseDialog({ license }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const currentLicensePool = useAppSelector((state) => state.licensepool.currentLicensePool)

  const handleClickDeleteLicenseGroup = () => {
    if (currentLicensePool === undefined) {
      return
    }

    setIsLoading(true)

    licenseService
      .deleteLicense(license.id)
      .then(() => {
        dispatch(removeLicense(license))

        licensePoolService
          .getLicensePool(currentLicensePool.id)
          .then((licensePool) => {
            dispatch(updateLicensePool(licensePool))
            dispatch(setCurrentLicensePool(licensePool))
            setIsLoading(false)
            handleClose()
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <DeleteIcon sx={{ marginRight: 1 }} />
        Delete
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{"Delete License"}</DialogTitle>
        <DialogContent>
          <DialogContentText>{"Are you sure you want to delete the license?"}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Box sx={{ m: 1, position: "relative" }}>
            <Button
              variant="contained"
              onClick={handleClickDeleteLicenseGroup}
              disabled={isLoading}
              sx={{ backgroundColor: hiabColors.redPrimary }}
            >
              Delete
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  )
}
